var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  active: _vm.isActive,
  search: true
  }},[_c('Autocomplete',{attrs:{"id":"searchbox","url":"/api/search","anchor":"title","label":"type","placeholder":"Search for a brewery or owner …","labelType":"type","classes":{item: 'autocomplete-item'},"min":_vm.min,"on-select":_vm.itemSelected,"process":_vm.processJsonData,"on-focus":_vm.setActive,"on-blur":_vm.unsetActive}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18bb8420","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSearch.vue
// module id = null
// module chunks = 